import { Inline } from "PFComponents/containers";
import DropDown, { DropdownOption } from "PFComponents/dropdown/dropdown";
import { Icon } from "PFComponents/icon";
import i18n from "PFCore/i18n";
import { ReactElement, useMemo } from "react";

import { getChatSendOnEnter, setChatSendOnEnter } from "./send_on_enter";

type ChatListMenuProps = {
  forceUpdateAll?: () => void;
  markAllRead: () => void;
  handleChange: (fn: () => void) => void;
};

export const ChatListMenu = ({ markAllRead, handleChange }: ChatListMenuProps) => {
  const sendsOnEnter = getChatSendOnEnter();

  const options: DropdownOption[] = useMemo(() => {
    const items: DropdownOption[] = [];
    const addOption = (id: string, el: ReactElement | string | null, fn: () => void) =>
      items.push({ id, displayElement: el || id, item: fn });

    addOption(
      sendsOnEnter ? "_show" : "_hide",
      <Inline alignItems="center">
        {sendsOnEnter && <Icon name="check" size="sm" />}
        {i18n.t("core:chat.menu.pressEnterToSend")}
      </Inline>,
      () => {
        setChatSendOnEnter(!sendsOnEnter);
      }
    );

    addOption("mark_all_read", i18n.t("core:chat.menu.markAllRead"), markAllRead);

    return items;
  }, [sendsOnEnter, markAllRead]);

  return (
    <DropDown
      style={{
        width: 210,
        minWidth: 210,
        right: 8,
        top: 32,
        maxHeight: 300
      }}
      options={options}
      selectedIndex={-1}
      handleClose={() => {}}
      // TODO: [PROF-6268] Fix types in DropDown handleChange
      // @ts-ignore - Related to PROF-6268
      handleChange={handleChange}
    />
  );
};
